import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import Contributor from './Contributor'

function ContributorContainer() {
  const [navParams, setNavParams] = useState({
    navTitle: "Contributor",
    navSubTitle: "Welcome to ImagesBazaar"
  })

  const handleNavParams = (obj)=>{
    setNavParams({
        ...navParams,
        ...obj
    })
  }
  return (
    <MainLayout navTitle={navParams.navTitle} navSubTitle={navParams.navSubTitle}>
      <Contributor handleNavParams={handleNavParams}/>
    </MainLayout>
  )
}

export default ContributorContainer